<div class="modal-header">
  <h4 class="modal-title">{{ 'SALES.SALES_REQUESTS_FORM.FORM_TITLE' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
</div>

<div class="modal-body sales-requests-body">
  <ng-scrollbar #requestsScrollbar orientation="vertical" visibility="native" appearance="compact" class="sales-requests-scrollbar">
    <div class="sales-requests-content">
      <form id="sale-requests-form" [formGroup]="form" (ngSubmit)="save()" novalidate>
        <div class="event-details d-flex flex-wrap">
          <div class="w-100">
            <div class="modal-section-title">{{ 'SALES.SALES_REQUESTS_FORM.EVENT_DETAILS' | translate }}</div>
          </div>

          <div class="section" *ngIf="sale?.event">
            <div class="sub-title">{{ 'SALES.SALES_REQUESTS_FORM.EVENT' | translate }}</div>
            <a [routerLink]="['/events/view']" [queryParams]="{ id: sale?.event?.id }" target="_blank">{{ sale?.event?.formattedName }}</a>
          </div>

          <div class="section" *ngIf="sale?.event?.date_from">
            <div class="sub-title">{{ 'SALES.SALES_REQUESTS_FORM.FROM' | translate }}</div>
            {{ sale?.event?.date_from | date : env.pipeDateFormat }}
          </div>

          <div class="section" *ngIf="sale?.event?.date_to">
            <div class="sub-title">{{ 'SALES.SALES_REQUESTS_FORM.TO' | translate }}</div>
            {{ sale?.event?.date_to | date : env.pipeDateFormat }}
          </div>

          <div class="section" *ngIf="sale?.event?.venue">
            <div class="sub-title">{{ 'SALES.SALES_REQUESTS_FORM.VENUE' | translate }}</div>
            <a [routerLink]="['/settings/venues/view']" [queryParams]="{ id: sale?.event?.venue.id }" target="_blank">{{ sale?.event?.venue?.name }}</a>
          </div>

          <div class="section" *ngIf="sale?.event?.venue?.city?.country?.name">
            <div class="sub-title">{{ 'SALES.SALES_REQUESTS_FORM.COUNTRY' | translate }}</div>
            {{ sale?.event?.venue?.city?.country?.name }}
          </div>

          <div class="section" *ngIf="sale?.event?.venue?.city?.name">
            <div class="sub-title">{{ 'SALES.SALES_REQUESTS_FORM.CITY' | translate }}</div>
            {{ sale?.event?.venue?.city?.name }}
          </div>
        </div>

        <hr />

        <div class="shared-actions" [formGroup]="massActionsForm">
          <div class="shared-fields-holder">
            <div class="modal-section-title">{{ 'SALES.SALES_REQUESTS_FORM.SHARED_FIELDS' | translate }}</div>
            <div class="shared-fields-grid">
              <div class="shared-field-cell shared-field-wide">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.LOCATION' | translate }}</label>
                <div class="shared-multi-control">
                  <ng-select
                    class="shared-multi-select"
                    formControlName="location_options"
                    [items]="locationOptions"
                    bindLabel="label"
                    bindValue="value"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [clearable]="false"
                    appendTo="body"
                  >
                    <ng-template ng-option-tmp let-item="item" let-item$="item$">
                      <div *ngIf="item.value !== 'free_text'" class="dropdown-checkbox-option">
                        <input type="checkbox" [checked]="item$.selected" tabindex="-1" aria-hidden="true" />
                        <span>{{ item.label | translate }}</span>
                      </div>
                      <div
                        *ngIf="item.value === 'free_text'"
                        class="dropdown-free-text-option"
                        (mousedown)="$event.stopPropagation()"
                        (click)="$event.stopPropagation()"
                      >
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          [formControl]="$any(massActionsForm.get('custom_location'))"
                          [attr.aria-label]="'SALES.SALES_REQUESTS_FORM.FREE_TEXT' | translate"
                          [placeholder]="'SALES.SALES_REQUESTS_FORM.FREE_TEXT' | translate"
                          (focus)="!hasSharedOption('location_options', 'free_text') && massActionsForm.get('location_options')?.setValue((massActionsForm.get('location_options')?.value || []).concat(['free_text']))"
                          (keydown)="$event.stopPropagation()"
                        />
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <span *ngIf="item.value !== 'free_text'">{{ item.label | translate }}</span>
                      <span *ngIf="item.value === 'free_text'">{{ massActionsForm.get('custom_location')?.value || (item.label | translate) }}</span>
                    </ng-template>
                  </ng-select>
                  <button
                    *ngIf="massActionsForm.get('location_options')?.value?.length"
                    type="button"
                    class="shared-input-clear"
                    [attr.aria-label]="'Clear ' + ('SALES.SALES_REQUESTS_FORM.LOCATION' | translate)"
                    (mousedown)="$event.stopPropagation()"
                    (click)="massActionsForm.get('location_options')?.setValue([]); massActionsForm.get('custom_location')?.setValue('')"
                  >&times;</button>
                </div>
              </div>

              <div class="shared-field-cell">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.MEAL_PLAN' | translate }}</label>
                <app-type-select [parentFormGroup]="massActionsForm" [passFormControlName]="'meal_plan_id'" [groupType]="'room_meal_plans'"></app-type-select>
              </div>

              <div class="shared-field-cell">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.HOTEL_STARS' | translate }}</label>
                <div class="shared-select-control">
                  <select class="form-control shared-stars-select" formControlName="hotel_stars">
                    <option [ngValue]="null">{{ 'SALES.SALES_REQUESTS_FORM.ALL_STARS' | translate }}</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                  <button
                    *ngIf="massActionsForm.get('hotel_stars')?.value != null"
                    type="button"
                    class="shared-input-clear"
                    [attr.aria-label]="'Clear ' + ('SALES.SALES_REQUESTS_FORM.HOTEL_STARS' | translate)"
                    (click)="massActionsForm.get('hotel_stars')?.setValue(null)"
                  >&times;</button>
                </div>
              </div>

              <div class="shared-field-cell">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.HOTEL' | translate }}</label>
                <div class="shared-text-control">
                  <input type="text" class="form-control" formControlName="hotel_text" />
                  <button
                    *ngIf="massActionsForm.get('hotel_text')?.value"
                    type="button"
                    class="shared-input-clear"
                    [attr.aria-label]="'SALES.SALES_REQUESTS_FORM.HOTEL' | translate"
                    (click)="massActionsForm.get('hotel_text')?.setValue('')"
                  >&times;</button>
                </div>
              </div>

              <div class="shared-field-cell shared-field-wide">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.BUDGET' | translate }}</label>
                <div class="shared-multi-control">
                  <ng-select
                    class="shared-multi-select"
                    formControlName="budget_options"
                    [items]="budgetOptions"
                    bindLabel="label"
                    bindValue="value"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [clearable]="false"
                    appendTo="body"
                  >
                    <ng-template ng-option-tmp let-item="item" let-item$="item$">
                      <div *ngIf="item.value !== 'free_text'" class="dropdown-checkbox-option">
                        <input type="checkbox" [checked]="item$.selected" tabindex="-1" aria-hidden="true" />
                        <span>{{ item.label | translate }}</span>
                      </div>
                      <div
                        *ngIf="item.value === 'free_text'"
                        class="dropdown-free-text-option"
                        (mousedown)="$event.stopPropagation()"
                        (click)="$event.stopPropagation()"
                      >
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          [formControl]="$any(massActionsForm.get('custom_budget'))"
                          [attr.aria-label]="'SALES.SALES_REQUESTS_FORM.FREE_TEXT' | translate"
                          [placeholder]="'SALES.SALES_REQUESTS_FORM.FREE_TEXT' | translate"
                          (focus)="!hasSharedOption('budget_options', 'free_text') && massActionsForm.get('budget_options')?.setValue((massActionsForm.get('budget_options')?.value || []).concat(['free_text']))"
                          (keydown)="$event.stopPropagation()"
                        />
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <span *ngIf="item.value !== 'free_text'">{{ item.label | translate }}</span>
                      <span *ngIf="item.value === 'free_text'">{{ massActionsForm.get('custom_budget')?.value || (item.label | translate) }}</span>
                    </ng-template>
                  </ng-select>
                  <button
                    *ngIf="massActionsForm.get('budget_options')?.value?.length"
                    type="button"
                    class="shared-input-clear"
                    [attr.aria-label]="'Clear ' + ('SALES.SALES_REQUESTS_FORM.BUDGET' | translate)"
                    (mousedown)="$event.stopPropagation()"
                    (click)="massActionsForm.get('budget_options')?.setValue([]); massActionsForm.get('custom_budget')?.setValue('')"
                  >&times;</button>
                </div>
              </div>
            </div>
          </div>

          <div class="mass-status-holder">
            <div class="modal-section-title">{{ 'SALES.SALES_REQUESTS_FORM.MASS_ACTIONS' | translate }}</div>
            <div class="mass-status-row">
              <div class="mass-status-select">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.STATUS' | translate }}</label>
                <app-type-select [parentFormGroup]="massActionsForm" [passFormControlName]="'status_id'" [groupType]="'sale_request'"></app-type-select>
              </div>
            </div>
          </div>

          <div class="shared-fields-actions">
            <button type="button" class="btn btn-link pointer ps-0" (click)="toggleCheckAll()">
              <ng-container *ngIf="!checkAll">{{ 'SALES.SALES_REQUESTS_FORM.CHECK_ALL' | translate }}</ng-container>
              <ng-container *ngIf="checkAll">{{ 'SALES.SALES_REQUESTS_FORM.UNCHECK_ALL' | translate }}</ng-container>
            </button>
            <button type="button" class="btn btn-success btn-input" [disabled]="checkedRequestsCount === 0" (click)="applyToChecked()">
              <i class="fal fa-level-down"></i>
              {{ 'SALES.SALES_REQUESTS_FORM.APPLY_SHARED_FIELDS' | translate }}
            </button>
          </div>
        </div>

        <hr />

        <div formArrayName="requests" class="request-list">
          <div
            *ngFor="let request of requests.controls; let I = index"
            [formGroupName]="I"
            class="single-request"
            [style.border-left-color]="request.get('note_color')?.value || '#e5e6ea'"
          >
            <div class="request-order">
              <div class="number">{{ I + 1 }}</div>
              <input
                type="number"
                min="1"
                [max]="requests.length"
                class="form-control request-position-input"
                [ngModel]="I + 1"
                [ngModelOptions]="{ standalone: true }"
                (change)="moveRequestTo(I, $any($event.target).value)"
              />
              <input type="checkbox" formControlName="metaFrontCheckBox" (change)="syncMassActionsFromCheckedRequests()" />

              <div class="request-sort-actions" *ngIf="requests.length > 1">
                <button
                  *ngIf="I > 0"
                  type="button"
                  class="btn btn-success btn-ico btn-sorting"
                  [ngbTooltip]="'SALES.SALES_REQUESTS_FORM.MOVE_UP' | translate"
                  container="body"
                  (click)="moveUp(I)"
                ><i class="fal fa-arrow-up"></i></button>
                <button
                  *ngIf="I + 1 < requests.length"
                  type="button"
                  class="btn btn-success btn-ico btn-sorting"
                  [ngbTooltip]="'SALES.SALES_REQUESTS_FORM.MOVE_DOWN' | translate"
                  container="body"
                  (click)="moveDown(I)"
                ><i class="fal fa-arrow-down"></i></button>
              </div>
            </div>

            <div class="request-fields-grid">
              <div class="request-field request-date-field">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.CHECK_IN' | translate }}</label>
                <app-date-picker [FormControl]="request.get('check_in')"></app-date-picker>
              </div>

              <div class="request-field request-date-field">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.CHECK_OUT' | translate }}</label>
                <app-date-picker [FormControl]="request.get('check_out')"></app-date-picker>
              </div>

              <div class="request-field request-type-field">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.TYPE' | translate }}</label>
                <app-type-select [parentFormGroup]="request" [passFormControlName]="'type_id'" [groupType]="'rooms'"></app-type-select>
              </div>

              <div class="request-field request-number-field">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.PEOPLE' | translate }}</label>
                <input type="number" min="1" class="form-control" formControlName="people" (change)="syncGuestNames(I)" />
              </div>

              <div class="request-field request-number-field">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.ROOM_COUNT' | translate }}</label>
                <input type="number" min="1" class="form-control" formControlName="count" (change)="syncGuestNames(I)" />
              </div>

              <div class="request-field request-guests-field">
                <div class="request-field-heading">
                  <label>{{ 'SALES.SALES_REQUESTS_FORM.GUEST_NAMES' | translate }}</label>
                  <button
                    type="button"
                    class="btn btn-primary btn-guest-details"
                    [disabled]="!canEditGuestNames(request)"
                    [ngbTooltip]="'SALES.SALES_REQUESTS_FORM.EDIT_GUEST_NAMES_DETAILS' | translate"
                    container="body"
                    (click)="openGuestNames(request, I)"
                  ><i class="fal fa-plus"></i></button>
                </div>

                <div class="guest-name-inputs" formArrayName="guest_names">
                  <input
                    *ngFor="let guestName of request.get('guest_names').controls; let J = index"
                    type="text"
                    class="form-control"
                    [formControlName]="J"
                  />
                  <span *ngIf="request.get('guest_names').controls.length === 0" class="empty-guest-names">
                    {{ 'SALES.SALES_REQUESTS_FORM.SET_PEOPLE_AND_ROOMS' | translate }}
                  </span>
                </div>
              </div>

              <div class="request-field request-note-column">
                <div class="request-note-group" [class.expanded]="isNoteExpanded(request)">
                  <div class="request-field-heading request-note-header">
                    <label>{{ 'SALES.SALES_REQUESTS_FORM.NOTE' | translate }}</label>
                    <div class="request-note-actions">
                      <input
                        type="color"
                        class="color-picker-custom request-note-color"
                        [ngModel]="request.get('note_color')?.value || noteDefaultColor"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="setRequestNoteColor(request, $event)"
                      />
                      <button
                        type="button"
                        class="btn btn-light btn-ico btn-request-note-action"
                        [ngbTooltip]="'SALES.SALES_REQUESTS_FORM.CLEAR_COLOR' | translate"
                        container="body"
                        (click)="clearRequestNoteColor(request)"
                      ><i class="fal fa-times"></i></button>
                      <button
                        type="button"
                        class="btn btn-light btn-ico btn-request-note-action"
                        [ngbTooltip]="(isNoteExpanded(request) ? ('COLLAPSE' | translate) : ('EXPAND' | translate))"
                        container="body"
                        (click)="toggleNoteExpanded(request)"
                      ><i class="fal" [ngClass]="isNoteExpanded(request) ? 'fa-compress-alt' : 'fa-expand-alt'"></i></button>
                    </div>
                  </div>

                  <input *ngIf="!isNoteExpanded(request)" type="text" class="form-control" formControlName="note" />
                  <textarea
                    *ngIf="isNoteExpanded(request)"
                    class="form-control request-note-textarea"
                    formControlName="note"
                    pInputTextarea
                    autoResize="true"
                  ></textarea>
                </div>
              </div>

              <div class="request-field request-status-field">
                <label>{{ 'SALES.SALES_REQUESTS_FORM.STATUS' | translate }}</label>
                <app-type-select [parentFormGroup]="request" [passFormControlName]="'status_id'" [groupType]="'sale_request'"></app-type-select>
              </div>
            </div>

            <div class="request-row-actions">
              <button
                type="button"
                class="remove-request-row"
                [ngbTooltip]="'DELETE_BUTTON.DELETE' | translate"
                container="body"
                (click)="removeRequest(I)"
              ><i class="fal fa-times"></i></button>
              <button
                type="button"
                class="duplicate-request-row"
                [ngbTooltip]="'SALES.SALES_REQUESTS_FORM.DUPLICATE' | translate"
                container="body"
                (click)="duplicateRequest(request)"
              ><i class="fal fa-copy"></i></button>
              <button
                *ngIf="request.get('count')?.value > 1"
                type="button"
                class="btn btn-primary btn-ico btn-split-icon"
                [ngbTooltip]="'SALES.SALES_REQUESTS_FORM.SPLIT' | translate"
                container="body"
                (click)="splitRequest(I)"
              ></button>
            </div>
          </div>
        </div>

        <div class="text-end pt-3">
          <button type="button" class="btn btn-primary" (click)="addRequest()">{{ 'SALES.SALES_REQUESTS_FORM.ADD_REQUEST' | translate }}</button>
        </div>
      </form>
    </div>
  </ng-scrollbar>
</div>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="sale-requests-form" [disabled]="form.invalid || requests.length === 0">
    {{ 'SALES.SALES_REQUESTS_FORM.SAVE' | translate }}
  </button>
</div>
